export default function fs () {
  return {
    'root': {
      'type': 'folder',
      'contents': {
        'folder': {
          'type': 'folder',
          'contents': {
            'test.txt': {
              'type': 'txt',
              'contents': 'this is a test file hmmm'
            }
          }
        },
        'test.txt': {
          'type': 'txt',
          'contents': 'test file 1'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/natos/fs.js